import { render, staticRenderFns } from "./SummaryByCaseType.vue?vue&type=template&id=4587d9b8&scoped=true&"
import script from "./SummaryByCaseType.vue?vue&type=script&lang=js&"
export * from "./SummaryByCaseType.vue?vue&type=script&lang=js&"
import style0 from "./SummaryByCaseType.vue?vue&type=style&index=0&id=4587d9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587d9b8",
  null
  
)

export default component.exports